import { Drawer } from "@/components";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "@/styles/containers/logs.module.scss";
import { ArrowLeft } from "@/components/Icons";
import { QrCodeReader } from "./Reader/QrCodeReader";

export function QRCodeDrawer({ title, onScan, onError, onClose }) {
  const streamRef = useRef(null);

  useEffect(() => {
    loadStream();

    return () => {
      stopQrCodeScan();
    };
  }, []);

  const loadStream = async () => {
    const getByFacingMode = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();

      console.log("[DEVICES]", devices);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });

      return stream;
    };

    const getByFallback = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((d) => d.kind === "videoinput");

      console.log("[DEVICES]", devices);

      const backCamera =
        videoDevices.find((d) => /back|rear|environment/i.test(d.label)) ||
        videoDevices[0];

      if (!backCamera) {
        throw new Error("Nenhuma câmera encontrada");
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: { exact: backCamera.deviceId },
        },
      });

      return stream;
    };

    const searchMethods = [getByFacingMode, getByFallback];

    try {
      await requestMediaPermission();
    } catch (err) {
      return onError({
        title: 'Falha no carregamento da câmera',
        message: err.message
      })
    }
    
    let lastError = null;
    for (const method of searchMethods) {
      try {
        streamRef.current = await method();
        return;
      } catch (err) {
        lastError = err;
        console.log(err);
      }
    }

    if (lastError) {
      return onError({
        title: 'Falha no carregamento da câmera',
        message: lastError.message
      })
    }

  };

  async function requestMediaPermission() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      stream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      if (err.name === "NotAllowedError") {
        throw new Error("Permissão de camera negada");
      }

      throw err;
    }
  }

  const onQrCodeScan = useCallback(
    (result, error) => {
      if (result && result.text) {
        return onScan({ data: result.text });
      }
    },
    [onScan]
  );

  const stopQrCodeScan = () => {
    if (streamRef.current) {
      streamRef.current.getVideoTracks().forEach((t) => t.stop());
    }
  };

  return (
    <Drawer open={true} onClose={onClose} withoutPadding>
      <div className={styles.logsContainer}>
        <div className={styles.header}>
          <div className={styles.back} onClick={onClose}>
            <ArrowLeft />
          </div>
          <p className={styles.title}>{title}</p>
        </div>

        {streamRef.current && (
          <QrCodeReader
            key="qr-scanner"
            scanDelay={800}
            onResult={onQrCodeScan}
            streamRef={streamRef}
            ViewFinder={ViewFinder}
            containerStyle={{ width: "100%", height: "calc(100vh - 105px)" }}
            videoContainerStyle={{
              paddingTop: 0,
              width: "100%",
              height: "100%",
            }}
            videoStyle={{
              color: "red",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}
      </div>
    </Drawer>
  );
}

const ViewFinder = () => (
  <>
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        flexDirection: "column",
      }}
    >
      <div style={{ flex: 1, background: "rgba(0,0,0,0.7)" }}></div>
      <div
        style={{
          boxSizing: "border-box",
          borderStyle: "solid",
          borderWidth: "100px 280px 100px 280px",
          borderColor: "rgba(0,0,0,0.7)",
          width: "100%",
          height: "100%",
          aspectRatio: 1,
        }}
      ></div>
      <div style={{ flex: 1, background: "rgba(0,0,0,0.7)" }}></div>
    </div>
  </>
);
